/** @module ChangeTracking/CodeRenderer */
define([
    "dojo/_base/declare",
    "dojo/dom-class",
    "csi/_base/underscore",
    "csi/heading/String",
    "csi/html"
], function(declare,domClass,_,StringRen,html) {

    var COLUMN_CODE = "Code";

    /**
     * Search in cached results and return node with given url
     * @param {Object} ctx - Context
     * @param {string} url
     * @return {Object} - result node
     */
    function getNode(ctx, url){
        return ctx.cache.getNode(url);
    }

    return declare(StringRen, {
        getQuerySpec: function(ctx, h, spec) {
            var qs = this.inherited(arguments);
            if (h.m_id == COLUMN_CODE) {
                qs.id = "DomainInstanceCode";
                qs.path = null;
            } else {
                qs.notFilterable = true;
            }
            return qs;
        },

        toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
            var node = ctx.getNode();
            if (!node) {
                return false;
            }
            if (h.m_id == COLUMN_CODE){
                // display current code
                // if filter is applied and among values to filter by is original code, display original code in ()
                var origCode = node.Code;
                var currCode = null;
                var currContext = ctx.cache.getNode(ctx.getNodeContext().CurrentContext);
                if (currContext) {
                    currCode = currContext.Code;
                }

                if (origCode == null && currCode == null) {
                    // if code attribute does not exist in original code and in current code, grey out the cell
                    domClass.add(refNode,html.CSS_NOT_APPLICABLE);
                    return;
                }

                this._toHtmlString(currCode, refNode, !ctx.bPrint);
                var filterCodes = ctx.view.getQueryValueAsLabel('DomainInstanceCode');
                _.some(filterCodes, function(code){
                    if ( (origCode != currCode) && (origCode.search(new RegExp(code, "i")) >= 0) ){
                        html.create("span", {"class":"", innerText: " (" + origCode + ")"}, refNode);
                        return true;
                    }
                });

                return true;
            }

            var node = ctx.getNode();
            if (!node) {
                return false;
            }

            var bContext1 = (h.m_nameOrig == "LogEntryContext1Code");
            var bContext2 = (h.m_nameOrig == "LogEntryContext2Code");
            var bContext3 = (h.m_nameOrig == "LogEntryContext3Code");
            var bContext4 = (h.m_nameOrig == "LogEntryContext4Code");

            if (bContext1 || bContext2 || bContext3 || bContext4){
                var instanceNode = getNode(ctx, node.OriginalContext);
                var parent = getNode(ctx, instanceNode.ParentContext);
                if (!parent){
                    // show our special shaded background if changed object has no context
                    domClass.add(refNode, html.CSS_NOT_APPLICABLE);
                    return false;
                }
                node = parent;
                if (bContext2 || bContext3 || bContext4) {
                    parent = getNode(ctx, node.ParentContext);
                    if (!parent){
                        // show our special shaded background if changed object has no context
                        domClass.add(refNode, html.CSS_NOT_APPLICABLE);
                        return false;
                    }
                    node = parent;
                }

                if (bContext3 || bContext4) {
                    parent = getNode(ctx, node.ParentContext);
                    if (!parent){
                        // show our special shaded background if changed object has no context
                        domClass.add(refNode, html.CSS_NOT_APPLICABLE);
                        return false;
                    }
                    node = parent;
                }

                if (bContext4) {
                    parent = getNode(ctx, node.ParentContext);
                    if (!parent){
                        // show our special shaded background if changed object has no context
                        domClass.add(refNode, html.CSS_NOT_APPLICABLE);
                        return false;
                    }
                    node = parent;
                }

                if (node.Code == null) {
                    // show our special shaded background if changed object has no code
                    domClass.add(refNode, html.CSS_NOT_APPLICABLE);
                    return false;
                }
                this._toHtmlString(node.Code, refNode, !ctx.bPrint);
                return true;
            }
        }
    });
});